'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _FormButton = require('../../../components/form/FormButton');

var _FormButton2 = _interopRequireDefault(_FormButton);

var _Form = require('../../../components/form/Form');

var _Form2 = _interopRequireDefault(_Form);

var _PrimaryErrorMessage = require('../../../components/form/messages/PrimaryErrorMessage');

var _PrimaryErrorMessage2 = _interopRequireDefault(_PrimaryErrorMessage);

var _CreditCardContainer = require('../../../components/form/creditCard/CreditCardContainer');

var _CreditCardContainer2 = _interopRequireDefault(_CreditCardContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PaymentForm = function PaymentForm(props) {
    var submitInterceptor = props.submitInterceptor,
        submitting = props.submitting,
        primaryError = props.primaryError,
        dirtySinceSubmission = props.dirtySinceSubmission,
        pristine = props.pristine;


    return _react2.default.createElement(
        _Form2.default,
        { onSubmit: submitInterceptor, className: 'PaymentForm' },
        _react2.default.createElement(
            'h1',
            null,
            'Update your credit card details'
        ),
        _react2.default.createElement(_CreditCardContainer2.default, props),
        _react2.default.createElement(_PrimaryErrorMessage2.default, { message: primaryError && primaryError.message,
            show: !!primaryError && !dirtySinceSubmission && !submitting }),
        _react2.default.createElement(
            _FormButton2.default,
            { type: 'submit', className: 'row payment', disabled: submitting || pristine },
            'Save changes'
        )
    );
};

PaymentForm.propTypes = {
    currentUser: _propTypes2.default.object,
    submitting: _propTypes2.default.bool,
    pristine: _propTypes2.default.bool,
    submitInterceptor: _propTypes2.default.func,
    primaryError: _propTypes2.default.object,
    dirtySinceSubmission: _propTypes2.default.bool
};

exports.default = PaymentForm;


//////////////////
// WEBPACK FOOTER
// ./src/client/user/account/updateCard/UpdateCardForm.js
// module id = 2104
// module chunks = 0